import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';

const ONBOARDING_RETURN_URL_KEY = 'recruiter_onboarding_return_url';

/**
 * Uses `afAuth.currentUser` (Promise) instead of `authState.pipe(take(1))`
 * to avoid a race: `authState` can emit a transient `null` before Firebase
 * finishes loading the persisted session (or right after signIn/signUp when
 * navigation fires immediately). The Promise resolves only after Firebase
 * has restored/updated the auth state, so it gives a stable answer.
 *
 * Guarda la URL solicitada en sessionStorage cuando redirige a login, para
 * que `navigateAfterAuth` (login/registro) pueda devolver al usuario a la
 * ruta original después de autenticarse.
 *
 * An anonymous identity only exists for the CV screening sandbox, so it never reaches the product:
 * it goes back to `/reclutador/sandbox`. Not to the login, where `noAuthGuard` would bounce it as a
 * signed-in user.
 */
export const authGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const afAuth = inject(AngularFireAuth);
  const router = inject(Router);

  const user = await afAuth.currentUser;
  if (user?.isAnonymous) return router.createUrlTree(['/reclutador/sandbox']);
  if (user) return true;

  sessionStorage.setItem(ONBOARDING_RETURN_URL_KEY, state.url);
  router.navigate(['/reclutador/login']);
  return false;
};
